'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getNodeFromCache;

var _calculateNodeScore = require('./calculateNodeScore');

var _calculateNodeScore2 = _interopRequireDefault(_calculateNodeScore);

var _queryNode = require('./queryNode');

var _queryNode2 = _interopRequireDefault(_queryNode);

var _createNode = require('./createNode');

var _createNode2 = _interopRequireDefault(_createNode);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getReference(_ref) {
  var type = _ref.type,
      _ref$media = _ref.media,
      media = _ref$media === undefined ? '' : _ref$media,
      _ref$support = _ref.support,
      support = _ref$support === undefined ? '' : _ref$support;
  return type + media + support;
}

function getNodeFromCache(attributes, renderer) {
  var reference = getReference(attributes);

  if (!renderer.nodes[reference]) {
    var score = (0, _calculateNodeScore2.default)(attributes, renderer.mediaQueryOrder);
    var node = (0, _queryNode2.default)(attributes) || (0, _createNode2.default)(renderer.nodes, score, attributes);
    renderer.nodes[reference] = {
      node: node,
      score: score
    };
  }

  return renderer.nodes[reference].node;
}